import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { siteData } from "@/store/siteData";

export default function StrategicPartners() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const partners = siteData.getPartners();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const totalProjects = partners.reduce((sum, p) => sum + p.projects, 0);

  return (
    <section id="ortaklar" data-edit="partners" ref={ref} className="bg-[#F8FAFC] py-24 border-t border-[#E2E8F0]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className={`flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-12 bg-[#3B82F6]"></div>
              <span className="text-[#334155] text-xs font-semibold tracking-[0.3em] uppercase">Güçlü Ekosistem</span>
            </div>
            <h2 className="text-[#0F172A] font-black uppercase leading-tight"
              style={{ fontSize: "clamp(28px, 4vw, 52px)", letterSpacing: "-0.02em" }}
            >
              Stratejik<br />
              <span className="text-[#64748B]">Ortaklarımız</span>
            </h2>
          </div>
          <div className="flex flex-col md:items-end gap-4">
            <p className="text-[#64748B] text-sm leading-relaxed max-w-sm md:text-right">
              Sektörün lider firmalarıyla {partners.length} stratejik ortaklık ve {totalProjects}+ ortak tamamlanan proje.
            </p>
            <Link
              to="/stratejik-ortaklarimiz"
              className="whitespace-nowrap inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-[#334155] border border-[#E2E8F0] hover:bg-[#3B82F6] hover:border-[#3B82F6] hover:text-white px-6 py-3 transition-all duration-300 cursor-pointer self-start md:self-auto"
            >
              Tüm Ortakları İncele
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Partners Strip */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#E2E8F0]">
          {partners.map((partner, i) => (
            <Link
              key={partner.id}
              to="/stratejik-ortaklarimiz"
              className={`group bg-[#F8FAFC] hover:bg-[#F1F5F9] flex flex-col items-center justify-center gap-3 p-7 transition-all duration-300 cursor-pointer ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {/* Icon placeholder */}
              <div className="w-12 h-12 flex items-center justify-center border border-[#E2E8F0] group-hover:border-[#3B82F6] transition-colors">
                <i className="ri-building-4-line text-[#64748B] group-hover:text-[#334155] text-xl transition-colors"></i>
              </div>
              <div className="text-center">
                <p className="text-[#0F172A] text-xs font-semibold leading-tight group-hover:text-[#334155] transition-colors">
                  {partner.name}
                </p>
                <p className="text-[#94A3B8] text-[10px] mt-1 tracking-wide">
                  {partner.projects}+ proje
                </p>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className={`flex flex-col sm:flex-row items-center justify-between gap-4 mt-8 p-6 border border-[#E2E8F0] bg-[#FFFFFF] transition-all duration-700 delay-500 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center border border-[#E2E8F0] bg-[#F1F5F9]">
              <i className="ri-links-line text-[#3B82F6] text-lg"></i>
            </div>
            <div>
              <p className="text-[#0F172A] text-sm font-semibold">
                Her ortak için sertifikalar, hizmet alanları ve başarı zaman çizelgesini inceleyin
              </p>
              <p className="text-[#94A3B8] text-xs mt-0.5">
                Detaylı bilgi, teknik kapasite ve ortaklık geçmişi
              </p>
            </div>
          </div>
          <Link
            to="/stratejik-ortaklarimiz"
            className="whitespace-nowrap flex-shrink-0 flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-white bg-[#3B82F6] hover:bg-[#64748B] px-6 py-3 transition-all duration-300 cursor-pointer"
          >
            Detaylı İncele
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
